import { useEffect, useCallback } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useAuthStore, useUIStore, useChatStore, useSpacesStore, useFeedStore } from "../context/store.js";
import Sidebar      from "../components/Sidebar.jsx";
import RightBar     from "../components/RightBar.jsx";
import FeedPage     from "./FeedPage.jsx";
import ExplorePage  from "./ExplorePage.jsx";
import SpacesPage   from "./SpacesPage.jsx";
import ChatPage     from "./ChatPage.jsx";
import AlertsPage   from "./AlertsPage.jsx";
import ProfilePage  from "./ProfilePage.jsx";
import CallModal    from "../components/CallModal.jsx";
import StreamModal  from "../components/StreamModal.jsx";
import IncomingCall from "../components/IncomingCall.jsx";

const B = {
  bg: "#08070F", bg2: "#0D0C18",
  border2: "rgba(124,58,237,0.08)",
  grad: "linear-gradient(135deg, #7C3AED, #10F5A0)",
  font: "'Sora', system-ui, sans-serif",
};

export default function AppShell() {
  const navigate    = useNavigate();
  const location    = useLocation();
  const { user }    = useAuthStore();
  const { tab, setTab, activeCall, showStream, setActiveCall, setShowStream, incomingCall, clearIncoming, setIncomingCall } = useUIStore();
  const fetchChats  = useChatStore(s => s.fetchChats);
  const fetchSpaces = useSpacesStore(s => s.fetchSpaces);
  const fetchVibes  = useFeedStore(s => s.fetchVibes);

  useEffect(() => {
    fetchVibes(true);
    fetchChats();
    fetchSpaces();
  }, []);



  const handleCall = useCallback((data) => {
    if (data.type === "stream") setShowStream(true);
    else setActiveCall(data);
  }, []);

  const currentTab = location.pathname.slice(1) || "feed";
  const hideRight  = ["chat","spaces"].includes(currentTab);

  const navTo = (t) => { setTab(t); navigate(`/${t}`); };

  return (
    <div style={{
      display: "flex", height: "100vh",
      maxWidth: 1320, margin: "0 auto",
      background: B.bg, fontFamily: B.font, overflow: "hidden",
    }}>
      {/* ── Sidebar ── */}
      <Sidebar onNav={navTo} onCall={handleCall} onStream={() => setShowStream(true)} />

      {/* ── Main content ── */}
      <main style={{ flex: 1, borderRight: `1px solid ${B.border2}`, display: "flex", flexDirection: "column", overflow: "hidden", minWidth: 0 }}>
        <Routes>
          <Route path="/"        element={<FeedPage    onCall={handleCall} onStream={() => setShowStream(true)} />} />
          <Route path="/feed"    element={<FeedPage    onCall={handleCall} onStream={() => setShowStream(true)} />} />
          <Route path="/explore" element={<ExplorePage onCall={handleCall} />} />
          <Route path="/spaces"  element={<SpacesPage  onStream={() => setShowStream(true)} onCall={handleCall} />} />
          <Route path="/chat"    element={<ChatPage     onCall={handleCall} />} />
          <Route path="/alerts"  element={<AlertsPage  />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/profile/:handle" element={<ProfilePage />} />
        </Routes>
      </main>

      {/* ── Right sidebar ── */}
      {!hideRight && <RightBar onCall={handleCall} />}

      {/* ── Modals ── */}
      {incomingCall && !activeCall && (
        <IncomingCall
          call={incomingCall}
          onAccept={() => { setActiveCall(incomingCall); clearIncoming(); }}
          onDecline={clearIncoming} />
      )}
      {activeCall && <CallModal call={activeCall} onClose={() => setActiveCall(null)} />}
      {showStream  && <StreamModal onClose={() => setShowStream(false)} />}
    </div>
  );
}
